export default "__VITE_ASSET__6fuJP3OA__"